import React from "react";

export default function RuntimeConfigurationFailure({ error }) {
  const production = process.env.REACT_APP_ENV === "production";
  return (
    <main role="alert" aria-live="assertive" style={{ maxWidth: 640, margin: "12vh auto", padding: 24 }}>
      <h1>NAVIG8 could not start safely</h1>
      <p>
        The application configuration is not ready. No account or deal data has been loaded.
      </p>
      {!production && (
        <p>
          Verify the Firebase project, App Check settings, and local environment, then retry.
          If the problem continues, contact support.
        </p>
      )}
      {!production && error?.message && <code>{error.message}</code>}
      <div style={{ marginTop: 20 }}>
        <button type="button" onClick={() => window.location.reload()}>Retry</button>
      </div>
    </main>
  );
}
